import { Directive } from '@angular/core';

@Directive({
    selector: '[trueFormMessages]',
    standalone: false
})
export class FormMessagesDirective {

  constructor() { }

}
